/* Nguyen Racing — rail arrows */
(() => {
  if (customElements.get('nr-rail')) return;
  class NrRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nr-rail__track');
      const root = this.closest('[data-nr-section]') || this;
      this.prev = root.querySelector('[data-nr-prev]');
      this.next = root.querySelector('[data-nr-next]');
      if (!this.track) return;
      const step = () => {
        const card = this.track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 12 : this.track.clientWidth * 0.8;
      };
      this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      const sync = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      };
      this.track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }
  customElements.define('nr-rail', NrRail);
})();
